export default [
  {
    path: '/dictionary',
    name: 'dictionary',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/DictionaryList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/employee',
    name: 'employee',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/employee/EmployeeList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/payrollitem',
    name: 'payrollitem',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/payrollItem/PayrollItem.vue'),
    meta: {},
  },
  {
    path: '/dictionary/employeetype',
    name: 'employeetype',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/employeeType/EmployeeType.vue'),
    meta: {},
  },
  {
    path: '/dictionary/budgetchapter',
    name: 'budgetchapter',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/budgetChapter/BudgetChapterList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/budgetgroupitem',
    name: 'budgetgroupitem',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/budgetGroupItem/BudgetGroupItemList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/budgesourceproperty',
    name: 'budgetsourceproperty',
    component: () =>
      import(/*webpackChunkName:'di'*/ '@/views/dictionary/budgetSourceProperty/BudgetSourcePropertyList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/budgetsource',
    name: 'budgetsource',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/budgetSource/BudgetSourceList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/activity',
    name: 'activity',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/activity/ActivityList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/budgetFees',
    name: 'budgetFees',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/budgetFees/BudgetFeesList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/budgetitem',
    name: 'budgetitem',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/budgetItem/BudgetItemList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/fixedasset',
    name: 'fixedasset',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/fixedAsset/FixedAssetList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/budgetkinditem',
    name: 'budgetkinditem',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/budgetKindItem/BudgetKindItemList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/systemaccounts',
    name: 'systemAccounts',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/systemAccounts/SystemAccounts.vue'),
    meta: {},
  },
  {
    path: '/dictionary/inventorycategory',
    name: 'inventorycategory',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/inventoryCategory/InventoryCategoryList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/inventoryitem',
    name: 'inventoryitem',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/inventory/InventoryList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/datamanagement/:key?',
    name: 'data-management',
    // component: () => import( '@/views/dictionary/dataManagement/DataManagement.vue'),
    component: () => import('@/views/dictionary/dataManagement/index.vue'),
    meta: {},
  },
  {
    path: '/dictionary/currency',
    name: 'currency',
    component: () => import('@/views/dictionary/currency/CurrencyList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/department',
    name: 'department',
    component: () => import('@/views/dictionary/department/DepartmentList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/typeoffund',
    name: 'typeOfFund',
    component: () => import('@/views/dictionary/typeOfFund/TypeOfFundList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/bankinfocategory',
    name: 'bankInfoCategory',
    component: () => import('@/views/dictionary/bankInfoCategorys/BankInfoCategoryList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/bankinfo',
    name: 'bankInfo',
    component: () => import('@/views/dictionary/bankInfo/BankInfoList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/statistic',
    name: 'statistic',
    component: () => import('@/views/dictionary/statistic/StatisticList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/purchasepurpose',
    name: 'purchasePurpose',
    component: () => import('@/views/dictionary/purchasePurpose/PurchasePurposeList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/accounttransfer',
    name: 'accountTransfer',
    component: () => import('@/views/dictionary/accountTransfer/AccountTransferList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/stock',
    name: 'stock',
    component: () => import('@/views/dictionary/stock/StockList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/autobusiness',
    name: 'autoBusiness',
    component: () => import('@/views/dictionary/autoBusiness/AutoBusinessList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/customervendor',
    name: 'customerVendor',
    component: () => import('@/views/dictionary/customerVendor/CustomerVendorList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/accountingobjectcategory',
    name: 'accountingObjectCategory',
    component: () => import('@/views/dictionary/accountingObjectCategory/AccountingObjectCategoryList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/invoiceformnumber',
    name: 'invoiceFormNumber',
    component: () => import('@/views/dictionary/invoiceFormNumber/InvoiceFormNumberList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/vouchertype',
    name: 'voucherType',
    component: () => import('@/views/dictionary/voucherType/VoucherTypeList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/contract',
    name: 'contract',
    component: () => import('@/views/dictionary/contract/ContractList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/project',
    name: 'project',
    component: () => import('@/views/dictionary/project/ProjectList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/task',
    name: 'task',
    component: () => import('@/views/dictionary/task/TaskList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/topic',
    name: 'topic',
    component: () => import('@/views/dictionary/topic/TopicList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/fundstructure',
    name: 'fundStructure',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/fundStructure/FundStructureList.vue'),
    meta: {},
  },
  {
    path: '/accountparallelrule',
    name: 'accountParallelRule',
    component: () =>
      import(/*webpackChunkName:'die'*/ '@/views/dictionary/accountParallelRule/AccountParallelRule.vue'),
    meta: {},
  },
  {
    path: '/dictionary/defaultaccount',
    name: 'defaultAccount',
    component: () => import('@/views/dictionary/defaultAccount/DefaultAccountList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/salaryscale',
    name: 'salaryScale',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/salaryScale/SalaryScale.vue'),
    meta: {},
  },
  {
    path: '/dictionary/budgetprovide',
    name: 'budgetprovide',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/budgetProvide/BudgetProvideList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/toollist',
    name: 'toolList',
    component: () => import('@/views/dictionary/tool/ToolList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/tooltype',
    name: 'toolType',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/toolType/ToolTypeList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/sysrole',
    name: 'sys-role',
    component: () => import('@/views/dictionary/systemUserRole/SystemUserRoleList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/advanced-security',
    name: 'advanced-security',
    component: () => import('@/views/dictionary/advancedSecurity/AdvancedSecurity.vue'),
    meta: {},
  },
  {
    path: '/dictionary/fixedassetcategory',
    name: 'fixedassetcategory',
    component: () =>
      import(/*webpackChunkName:'di'*/ '@/views/dictionary/fixedAssetCategory/FixedAssetCategoryList.vue'),
    meta: {},
  },
  {
    path: '/dictionary/settingesignallproject',
    name: 'setting-esign-all-project',
    component: () => import('@/views/invoice/setting_esign/SettingEsignAllProject.vue'),
    meta: {},
  },
  {
    path: '/license-extend',
    name: 'licenseExtend',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/license/LicenseExtend.vue'),
    meta: {},
  },
];
